import { render, staticRenderFns } from "./ChallengeEdit.vue?vue&type=template&id=d3f434ee&scoped=true&lang=pug&"
import script from "./ChallengeEdit.vue?vue&type=script&lang=js&"
export * from "./ChallengeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeEdit.vue?vue&type=style&index=0&id=d3f434ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f434ee",
  null
  
)

export default component.exports